import type { SxProps } from "@mui/material"

export interface GetBlurSxProps {
  blurRadius?: number
  isBlurred?: boolean
}

export const getBlurSx = ({
  blurRadius = 4,
  isBlurred = true,
}: GetBlurSxProps): SxProps => {
  return {
    filter: isBlurred ? `blur(${blurRadius}px)` : "none",
    pointerEvents: isBlurred ? "none" : "auto",
  }
}
